// extracted by mini-css-extract-plugin
export default {"container":"User_container__cL3r4","profile-image":"User_profile-image__QQeJL","username":"User_username__IX4BZ","mainphoto":"User_mainphoto__m0ar3"};